import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';

import ContentLinks from './ContentLinks';

export default function NearbyCities({ links, ...rest }) {
	const computedLinks = map(links, ({ city, uri }) => ({
		label: city,
		uri: `/${uri}`,
	}));

	return (
		<ContentLinks
			{...rest}
			columns={3}
			links={computedLinks}
		/>
	);
}

NearbyCities.propTypes = {
	links: PropTypes.arrayOf(
		PropTypes.shape({
			city: PropTypes.string,
			uri: PropTypes.string,
		}),
	),
};
